import { Glyphs } from "@lookiero/aurora-iconfont";
import { FeatureIds } from "../../../../../../domain/entities/product/Features";

const ICON_BY_FEATURE_ID: Record<string, keyof Glyphs> = {
  [FeatureIds.MILD_WASH_30]: "wash_30_soft",
  [FeatureIds.VERY_MILD_WASH_30]: "wash_30_delicate",
  [FeatureIds.WASH_30]: "wash_30",
  [FeatureIds.MILD_WASH_40]: "wash_40_soft",
  [FeatureIds.VERY_MILD_WASH_40]: "wash_40_delicate",
  [FeatureIds.WASH_40]: "wash_40",
  [FeatureIds.MILD_WASH_60]: "wash_60_soft",
  [FeatureIds.WASH_60]: "wash_60",
  [FeatureIds.WASH_70]: "wash_70",
  [FeatureIds.WASH_95]: "wash_95",
  [FeatureIds.ANY_BLEACH_ALLOWED]: "bleach_if_needed",
  [FeatureIds.DO_NOT_BLEACH]: "do_not_bleach",
  [FeatureIds.DO_NOT_DRY_CLEAN]: "do_not_dry_clean",
  [FeatureIds.DO_NOT_IRON]: "do_not_iron",
  [FeatureIds.DO_NOT_TUMBLE_DRY]: "do_not_tumble_dry",
  [FeatureIds.DO_NOT_WASH]: "do_not_wash",
  [FeatureIds.DO_NOT_WET_CLEAN]: "do_not_wet_clean",
  [FeatureIds.DRIP_FLAT_DRYING]: "drip_dry_flat",
  [FeatureIds.DRIP_FLAT_DRYING_IN_THE_SHADE]: "drip_dry_flat_shade",
  [FeatureIds.DRIP_LINE_DRYING]: "drip_dry",
  [FeatureIds.DRIP_LINE_DRYING_IN_THE_SHADE]: "drip_dry_shade",
  [FeatureIds.FLAT_DRYING]: "dry_flat",
  [FeatureIds.FLAT_DRYING_IN_THE_SHADE]: "dry_flat_shade",
  [FeatureIds.HAND_WASH]: "wash_hand",
  [FeatureIds.IRON_AT_HIGH_TEMPERATURE]: "steam_high",
  [FeatureIds.IRON_AT_LOW_TEMPERATURE]: "steam_low",
  [FeatureIds.IRON_AT_MODERATE_TEMPERATURE]: "steam_medium",
  [FeatureIds.LINE_DRYING]: "hang_to_dry",
  [FeatureIds.LINE_DRYING_IN_THE_SHADE]: "hang_to_dry_shade",
  [FeatureIds.MILD_PROFESSIONAL_WET_CLEAN]: "wet_clean_delicate",
  [FeatureIds.MILD_TUMBLE_DRY]: "dry_normal_low",
  [FeatureIds.NORMAL_TUMBLE_DRY]: "dry_normal_medium",
  [FeatureIds.ONLY_OXYGEN_BLEACH_ALLOWED]: "non_chlorine_bleach",
  [FeatureIds.PROFESSIONAL_DRY_CLEAN_IN_HYDROCARBONS]: "any_solvent",
  [FeatureIds.PROFESSIONAL_DRY_CLEAN_IN_PERCHLOROETHYLENE]: "short_cycle",
  [FeatureIds.PROFESSIONAL_MILD_DRY_CLEAN_IN_HYDROCARBONS]: "any_solvent_delicate",
  [FeatureIds.PROFESSIONAL_MILD_DRY_CLEAN_IN_PERCHLOROETHYLENE]: "dry_clean_delicate",
  [FeatureIds.PROFESSIONAL_WET_CLEAN]: "wet_clean",
  [FeatureIds.VERY_MILD_PROFESSIONAL_WET_CLEAN]: "wet_clean_very_delicate",
};

export { ICON_BY_FEATURE_ID };
